import Button from "../../components/shared/button";
import React from "react";

const RoleLayout: React.FC = () => {
  return (
    <view data-scroll="" >
      <group>
        <group
          data-background="main"
          data-color="white"
          data-space="20"
          data-wrap="no"
          data-align="center"
          data-gap="10"
        >
          <group data-direction="column" data-gap="15" data-space="10">
            <text data-weight="700" data-text-size="xxx-large" data-wrap="wrap">
              Sample UI Pattern
            </text>
            <text

              data-wrap="wrap"
              data-length="600"
              data-line="20"
              data-light=""
            >
              Some info may be visible to other people using Our services. In
              publishing and graphic design, Lorem ipsum is a placeholder text
              commonly used to demonstrate the visual form of a document or a
              typeface without relying on meaningful content.
            </text>
          </group>
        </group>
        <group data-sticky="top" data-background="main">
          <group>
            <nav className="nav_strip classic " data-space-horizontal="10">
              <space data-height="10"></space>
              <ul>
                <li>
                  <text data-space="10">Administrator</text>
                </li>
                <li className="selected">
                  <text data-space="10">Another User</text>
                </li>
              </ul>
            </nav>
          </group>
        </group>
        <group data-space="20" data-type="column">
          <group data-space="10" data-gap="30">
            <group data-direction="column" data-gap="5">
              <text
                data-weight="700"
                //data-space-horizontal="10"

                data-color="main"
                data-text-size="large"
              >
                Factory
              </text>
              <text data-light="" data-wrap="wrap" data-line="1.5">Some info may be visible to other people using Our services.</text>
            </group>
            <group

              data-radius="10"
              data-contain=""
              data-gap="1"
              data-border=""
            >
              <group data-align="center" data-space="10" data-border="" data-gap="10" >
                <Button micro rounded icon="info"></Button>
                <separator data-vertical="" data-height="20"></separator>
                <text>Add Factory</text>

                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>

              <group data-align="center" data-space="10" data-border="">
                <text>View Factory</text>
                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>

              <group data-align="center" data-space="10" data-border="">
                <text>Delete Factory</text>
                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>
            </group>
          </group>


          <group data-space="10" data-gap="30">
            <group data-direction="column" data-gap="5">
              <text
                data-weight="700"
                //data-space-horizontal="10"

                data-color="main"
                data-text-size="large"
              >
                Authorization
              </text>
              <text data-light="" data-wrap="wrap" data-line="1.5">Some info may be visible to other people using Our services.</text>
            </group>
            <group

              data-radius="10"
              data-contain=""
              data-gap="1"
              data-border=""
            >
              <group data-align="center" data-space="10" data-border="" data-gap="10" >

                <text>Add Factory</text>

                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>

              <group data-align="center" data-space="10" data-border="">
                <text>View Factory</text>
                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>

              <group data-align="center" data-space="10" data-border="">
                <text>Delete Factory</text>
                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>

              <group data-align="center" data-space="10" data-border="">
                <text>View Factory</text>
                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>

              <group data-align="center" data-space="10" data-border="">
                <text>Delete Factory</text>
                <group data-width="auto" data-position="right">
                  <div className="option_bar fixed animate">
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="true"
                      />
                      <wrap>
                        <text>Yes</text>
                      </wrap>
                    </label>
                    <label>
                      <input
                        type="radio"
                        placeholder=" "
                        name="role"
                        value="false"
                      />
                      <wrap>
                        <text>No</text>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>
            </group>
          </group>


          <group data-space="10" data-gap="30">
            <group data-direction="column" data-gap="5">
              <text
                data-weight="700"
                //data-space-horizontal="10"

                data-color="main"
                data-text-size="large"
              >
                Affinement de la solution
              </text>
              <text data-light="" data-wrap="wrap" data-line="1.5">Sélectionnez les besoins :</text>
            </group>


            <group
              data-radius="5"
              data-contain=""
              data-gap="1"
              data-border=""
              data-width="auto"
              data-name="interactive_grid"
            >
              <group data-align="center" data-space="10"  data-gap="5" data-border="">
                <group data-length="30" data-align="center" data-justify="center" data-space="5" data-gap="5">

                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>Volume</text>
                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>Puissance</text>
                </group>
              </group>



              <label data-type="group" data-align="center" data-space="10"  data-gap="5">
                <group data-length="30" data-align="center" data-justify="center" data-space="5" data-gap="5">
                  <label data-align="center" data-type="group">
                    <input
                      type="radio"
                      placeholder=" "
                      name="role"
                      value="true"
                    />
                  </label>
                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>300L</text>
                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>42 kW</text>
                </group>
              </label>
              <label data-type="group" data-align="center" data-space="10"  data-gap="5">
                <group data-length="30" data-align="center" data-justify="center" data-space="5" data-gap="5">
                  <label data-align="center" data-type="group">
                    <input
                      type="radio"
                      placeholder=" "
                      name="role"
                      value="true"
                    />
                  </label>
                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>300L</text>
                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>42 kW</text>
                </group>
              </label>
              <label data-type="group" data-align="center" data-space="10"  data-gap="5">
                <group data-length="30" data-align="center" data-justify="center" data-space="5" data-gap="5">
                  <label data-align="center" data-type="group">
                    <input
                      type="radio"
                      placeholder=" "
                      name="role"
                      value="true"
                    />
                  </label>
                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>300L</text>
                </group>
                <separator data-vertical="" data-height="20"></separator>
                <group data-length="100" data-align="center" data-justify="" data-space="5" data-gap="5">
                  <text>42 kW</text>
                </group>
              </label>
            </group>
          </group>


        </group>
      </group>

    </view>
  );
};
export default RoleLayout;
